import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import component from './component'
import { fetchSendEmailShoppingList } from './actions/data'
import { setEmailAddress } from './actions'


const mapStateToProps = state => ({
    ...state.emailSubscriptionForm,
    language: state.app.language
})

export default withRouter(connect(
    mapStateToProps,
    {
        setEmailAddress,
        fetchSendEmailShoppingList
    }
)(component))
